// import React from 'react'
// import dashboard from "../../../assests/dashboard.svg";
// import addCenter from "../../../assests/add-center.svg";
// import wallets from "../../../assests/wallets-tags.svg";
// import customer from "../../../assests/customerM.svg";
// import configure from "../../../assests/configuration.svg";
// import users from "../../../assests/user-roles.svg";
// import {MdOutlineKeyboardArrowDown} from "react-icons/md";
// import {MdOutlineKeyboardArrowUp} from "react-icons/md";


//  export const SidebarData = [
//     {
//       title: "Dashboard",
//       icon: `${dashboard}`,
//       path: "",
//       iconClosed:  <MdOutlineKeyboardArrowDown /> ,
//       iconOpened: <MdOutlineKeyboardArrowUp />,

//       subNav: [
//         {
//           title: "Reports and Analytics",

//           path: "/home/reportsandanalytics",
//         },
//         {
//           title: "Orders",

//           path: "/home/ordersview",
//         },
//         {
//           title: "Brand Categorization",
//           path: "/home/brandcategorization",
//         },
//         {
//           title: "Refill Suggestion",
//           path: "/home/refillsuggestion",
//         },

//       ],
//       index: 0,
//     },
//     {
//       title: "Add Center",
//       icon: `${addCenter}`, 
//       iconClosed:  <MdOutlineKeyboardArrowDown /> ,
//       iconOpened: <MdOutlineKeyboardArrowUp />,

//       subNav : [
//         {
//           title: "Screensavers",
//           path: "/home/addcenter/screensavers",
//           cName: "sub-nav",
//         },
//         {
//           title: "Coupons",
//           path: "/home/couponcreate",
//           cName: "sub-nav",
//         },
//       ],
//       index: 1,
//     },
//     {
//       title: "Wallets and Tags",
//       icon: `${wallets}`,

//       iconClosed:  <MdOutlineKeyboardArrowDown />,
//       iconOpened: <MdOutlineKeyboardArrowUp />,
//       subNav: [
//         {
//           title: "Daalchini points",
//           path: "/home/walletsandtags/daalchinipoints",
//         },

//         {
//           title: "Tag pay",
//           path: "/home/walletandtag/tagpymanagement",
//         },


//       ],
//       index: 2,
//     },

//     {
//       title: "Customer Manager",
//       icon: `${customer}`,

//       iconClosed:  <MdOutlineKeyboardArrowDown />,
//       iconOpened: <MdOutlineKeyboardArrowUp />,
//       subNav: [
//         {
//           title: "BP Management",
//           path: "/home/customermanager/bpmanagementlist",
//         },


//       ],
//       index: 3,
//     },
//     {
//       title: "Configuration",
//       icon: `${configure}`,

//       iconClosed:  <MdOutlineKeyboardArrowDown /> ,
//       iconOpened: <MdOutlineKeyboardArrowUp />,
//       subNav: [
//         {
//           title: "Vending machines",
//           path: "/home/configuration/vmlist",
//         },
//         {
//           title: "Cohorts",
//           path: "/home/configuration/cohorts",
//         },
//         {
//           title: "Warehouses",
//           path: "/home/configuration/warehouse",
//         },
//         {
//           title: "Products",
//           path: "/home/configuration/products",
//         },
//         {
//           title: "Manage Partners",
//           path: "/home/configuration/managepartners",
//         },
//       ],
//       index: 4,
//     },
//     {
//       title: "Users and Roles",
//       icon: `${users}`,
//       path: "/home/users/list",
//     },
//   ];

import React from 'react';
import dashboard from "../../../assests/dashboard.svg";
import addCenter from "../../../assests/add-center.svg";
import wallets from "../../../assests/wallets-tags.svg";
import customer from "../../../assests/customerM.svg";
import configure from "../../../assests/configuration.svg";
import users from "../../../assests/user-roles.svg";
import assortment from "../../../assests/assortment.svg";
import dgpayouticon from "../../../assests/dfpayouticon.svg"
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";

export const SidebarData = [
  // {
  //   title: "Dashboard",
  //   icon: dashboard,
  //   permissions: ["absolute_sales", "view_brands", "refill_suggestion"],
  //   iconClosed: <MdOutlineKeyboardArrowDown />,
  //   iconOpened: <MdOutlineKeyboardArrowUp />,
  //   subNav: [
  //     { title: "Reports and Analytics", path: "/home/reportsandanalytics", permissions: ["absolute_sales"] },
  //     { title: "Brand Categorization", path: "/home/brandcategorization", permissions: ["view_brands"] },
  //     { title: "Refill Suggestion", path: "/home/refillsuggestion", permissions: ["refill_suggestion"] },
  //   ],
  //   index: 0,
  // },
  {
    title: "Add Center",
    icon: addCenter,
    permissions: ["growth_dash_view", "banner_create", "create_coupon", "combo"],
    iconClosed: <MdOutlineKeyboardArrowDown />,
    iconOpened: <MdOutlineKeyboardArrowUp />,
    subNav: [
      // { title: "Screensavers", path: "/home/addcenter/screensavers", permissions: ["banner_create"] },
      { title: "Coupons", path: "/home/coupon/list", permissions: ["create_coupon"] },
      { title: "Combo", path: "/home/combolist", permissions: ["combo"] },
    ],
    index: 1,
  },
  // {
  //   title: "Wallets and Tags",
  //   icon: wallets,
  //   permissions: [ "view_tag"],
  //   iconClosed: <MdOutlineKeyboardArrowDown />,
  //   iconOpened: <MdOutlineKeyboardArrowUp />,
  //   subNav: [
  //     { title: "Tag pay", path: "/home/walletandtag/tagpymanagement", permissions: ["view_tag"] },
  //   ],
  //   index: 2,
  // },
  {
    title: "Wallets and Tags V2",
    icon: wallets,
    permissions: [ "view_tag"],
    iconClosed: <MdOutlineKeyboardArrowDown />,
    iconOpened: <MdOutlineKeyboardArrowUp />,
    subNav: [
      { title: "Tag pay", path: "/home/walletandtag/tagpymanagementv2", permissions: ["view_tag"] },
    ],
    index: 3,
  },
  // {
  //   title: "Customer Manager",
  //   icon: customer,
  //   permissions: ["view_bp_user"],
  //   iconClosed: <MdOutlineKeyboardArrowDown />,
  //   iconOpened: <MdOutlineKeyboardArrowUp />,
  //   subNav: [
  //     { title: "BP Management", path: "/home/customermanager/bpmanagementlist", permissions: ["view_bp_user"] },
      
  //   ],
  //   index: 4,
  // },
   {
    title: "Product 2.0",
    icon: customer,
    permissions: ["product_allowed"],
    iconClosed: <MdOutlineKeyboardArrowDown />,
    iconOpened: <MdOutlineKeyboardArrowUp />,
    // path: "/home/navigational/list",
    subNav: [
      {title: "Product Re-Structure" , path:"/home/configuration/product-restructure",  },
      { title: "Navigational Manager", path: "/home/navigational/list",permissions: ["product_allowed"] },
      
    ],
    index: 4,
  },
   {
    title: "Customer Manager",
    icon: customer,
    permissions: ["view_bp_user"],
    iconClosed: <MdOutlineKeyboardArrowDown />,
    iconOpened: <MdOutlineKeyboardArrowUp />,
    subNav: [
      { title: "Corporate Management", path: "/home/customermanager/corporatelist", permissions: ["view_bp_user", "DC_Admin"] },
      
    ],
    index: 5,
  },

  {
    title: "Configuration",
    icon: configure,
    permissions: ["vm_allowed", "cohort_view", "product_allowed", "view_franchisee", "view_payout", "product_expiry"],
    iconClosed: <MdOutlineKeyboardArrowDown />,
    iconOpened: <MdOutlineKeyboardArrowUp />,
    subNav: [
      { title: "Vending machines", path: "/home/configuration/vmlist", permissions: ["vm_allowed"] },
      { title: "Cohorts", path: "/home/configuration/cohortslist", permissions: ["cohort_view"] },
      { title: "Products", path: "/home/configuration/products", permissions: ["product_allowed"] },
      { title: "Manage Partners", path: "/home/configuration/managepartners", permissions: ["view_franchisee"] },
      { title: "Payout For Account", path: "/home/configuration/payoutpartners", permissions: ["view_payout"] },
      { title: "Product Expiry", path: "/home/configuration/productlist", permissions: ["product_expiry"] },
      {title: "Uid Dashboard" , path:"/home/configuration/uid-dashboard", permissions: ["uid_create"]}, 
      {title: "VMId Dashboard" , path:"/home/configuration/vmid-dashboard" , permissions: ["uid_create"]},
      
    ],
    index: 6,
  },
  {
    title: "Assortment",
    icon: assortment,
    permissions: ["assortment_view"],
    iconClosed: <MdOutlineKeyboardArrowDown />,
    iconOpened: <MdOutlineKeyboardArrowUp />,
    subNav: [
      { title: "Warehouses Assortment", path: "/home/assortment/assortmentwarehouse", permissions: ["assortment_view"] },
      { title: "Cohorts Assortment", path: "/home/assortment/assortmentcohortlist", permissions: ["assortment_view"] },
    ],
    index: 7,
  },
    {
    title: "DF Payout ",
    icon: dgpayouticon,
    permissions: ["df_payout_upload"],
 
     path: "/home/dfpayout/dfpayoutlist",
    index: 8,
  },
  {
    title: "Customer Support",
    icon: assortment,
    permissions: ["cst_dash_view"],
    iconClosed: <MdOutlineKeyboardArrowDown />,
    iconOpened: <MdOutlineKeyboardArrowUp />,
    subNav: [
      { title: "Orders", path: "/home/ordersview", permissions: ["cst_dash_view"] },
      { title: "Rooster", path: "/cst_rooster", permissions: ["cst_dash_view", ] },
    ],
    index: 9,
  },
 
  {
    title: "Users and Roles",
    icon: users,
    permissions: ["user_dash_view", "user_allowed"],
    path: "/home/users/list",
  },
];
